import request from "@/utils/request";


export default function agentAbleCard(params) {
    return request({
        url: `/user/card/agentAbleCard`,
        method: 'post',
        params: params
    })
}